import { tracked } from '@glimmer/tracking';

import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForShortUrlComponent extends Component {
  // Defaults
  @tracked isQuickAddOpen = false;

  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'productTargetType',
      type: 'selectValueLabel',
      options: [
        'amazon_download',
        'amazon_physical',
        'amazon_unlimited',
        'itunes',
        'spotify',
        'apple',
        'mediamarkt',
        'saturn',
      ],
    },
  ];

  defaultColumns = [
    'id',
    'urlHash',
    'urls',
    'product',
    'productTargetType',
    'targets',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'urlHash',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'artist',
      relationProperty: 'product.contributors.firstObject.artist',
      type: 'relation',
    },
    {
      property: 'product',
      type: 'relation',
    },
    {
      property: 'eventAction',
      sortable: true,
    },
    {
      property: 'productTargetType',
      sortable: true,
    },
    {
      property: 'targets',
      type: 'relation',
      isLinkDisabled: true,
      isTruncate: true,
    },
    {
      property: 'division',
      relationProperty:
        'product.contributors.firstObject.artist.divisions.firstObject',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];

  // Actions
  toggleQuickAdd = () => {
    this.isQuickAddOpen = !this.isQuickAddOpen;
  };
}
